<template>
  <div :class="['editor-detail-experience-skeleton', { _mobile: isMobile }]">
    <div class="editor-detail-experience-skeleton__title"></div>
    <ul class="editor-detail-experience-skeleton__list">
      <li v-for="index in 4" :key="index" class="editor-detail-experience-skeleton__item">
        <div class="editor-detail-experience-skeleton__name"></div>
        <div class="editor-detail-experience-skeleton__date"></div>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
const isMobile: boolean = useIsMobile();
</script>

<style lang="less">
.editor-detail-experience-skeleton {
  .flex-column(@size-x6);
  .box-shadow();

  padding: @size-x8;
  border-radius: @main-size;

  &__title {
    .skeleton(100px, 39px);
  }

  &__list {
    .flex-column(@size-x6);
  }

  &__item {
    .flex-column(@main-size);
  }

  &__name {
    .skeleton(60%, 21px);
  }

  &__date {
    .skeleton(30%, 18px);
  }

  &._mobile {
    padding: @size-x6;
  }

  &._mobile &__title {
    width: 90px;
    height: 30px;
  }

  &._mobile &__name {
    width: 90%;
  }

  &._mobile &__date {
    width: 50%;
  }
}
</style>
